import React, { useState, useEffect } from 'react';
import ContentLoader from "react-content-loader";
import { MESSAGE_TYPE, SUBSCRIPTION_MODULE_TYPE, USER_DASHBOARD_BULLION } from '../../../../constants';
import { useFieldArray, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserDashboardAction } from '../../../../actions/userDashboard';
import { useNavigate } from 'react-router';
import { RoutesPaths } from '../../../../Router/constant';
import { paymentModalAction, setPaymentMethodSelection, subscriptionPlan } from '../../../../actions/stripe';
import { getPlanProductAction } from '../../../../actions/subscriptionPlan';
import { companyLink } from '../../../../components/ContactUs/ContactUs';
import CurrencyFormat from "../../../../components/currencyFormat/currencyFormat";
import Currency from "../../../../components/currency/currency";

export default function CashBalance({ isEditing, setIsEditing, sendMessageToAdmin, adminLoader }) {

  const {
    control,
    reset,
    register,
    handleSubmit,
  } = useForm();
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { selectedCompany } = useSelector((state) => state.company);
  const { userDashboard, isUserDashboardLoading } = useSelector((state) => state.userDashboard);
  const { isAdminLoggedIn } = useSelector((state) => state.auth);
  const { productPlanList } = useSelector((state) => state.subscriptionPlanProducts);
  const { fields, append, remove } = useFieldArray({
    control,
    name: "cashBalanceRecord",
  });

  useEffect(() => {
    if (selectedCompany && selectedCompany?.id) {
      dispatch(getPlanProductAction(selectedCompany?.id, 1, 10000));
      dispatch(setPaymentMethodSelection(null));
    }
  }, [dispatch, selectedCompany])


  useEffect(() => {
    const getCashBalance = () => {
      reset();
      userDashboard && userDashboard?.cashBalanceRecord?.length > 0 && userDashboard?.cashBalanceRecord.forEach(element => {
        append({
          paidCurrency: element?.paidCurrency,
          paidAmount: element?.paidAmount,
          baseCurrency: element?.baseCurrency,
          baseAmount: element?.baseAmount
        })
      });
    }
    getCashBalance();
  }, [userDashboard])

  const onSubmit = async (data) => {
    await dispatch(updateUserDashboardAction(data))
    setIsEditing(null);
  };

  const addFunds = async () => {
    const slug = productPlanList?.filter(x => x?.planType?.value === SUBSCRIPTION_MODULE_TYPE.FUNDS)[0]?.slug
    const resp = productPlanList?.filter(x => x?.planType?.value === SUBSCRIPTION_MODULE_TYPE.FUNDS)[0]
    if (slug) {
      await dispatch(paymentModalAction(false, resp));
      dispatch(subscriptionPlan(resp));
      navigate(RoutesPaths.DASHBOARD_PRODUCT_PAGE.replace(":slug", slug));
    } else {
      navigate(RoutesPaths.PRODUCTS_LIST_PAGE)
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='accountBorderSection'>

          {isUserDashboardLoading ? (
            <div className='innercardClassInner'>
              <div className='row cashHederSectionPadding'>
                <div className='col-md-12'>
                  <div style={{ width: '100%', marginLeft: 'auto' }}>
                    <ContentLoader width="100%" height={15}>
                      <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                    </ContentLoader>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className='row cashHederSectionPadding'>
              <div className='col-md-5 col-6 button_align'>
                <h6 className='cashHeaderText cashDarkText m-0'>Cash balance</h6>
              </div>
            </div>
          )}



          <div className='col-12'><hr className='m-0'></hr></div>

          <div className="content-row-padding ps-0 pe-0 pb-0 cash-account">
            <div className='innercardClassInner'>
              <div className='row'>
                <div className={`col-4`}>
                  <p className='accountPrimaryText m-0'>Currency balance</p>
                </div>
                <div className={`col-4`}>
                  <p className='accountPrimaryText text-center m-0'>Paid currency</p>
                </div>
                <div className={`col-4`}>
                  <p className='accountPrimaryText m-0 text-right'>Balance</p>
                </div>
              </div>
            </div>
            {isUserDashboardLoading ? (
              <div className='innercardClassInner'>
                <div className='row'>
                  <div className='col-12 currentBalanceDetails'>
                    <ContentLoader width="100%" height={15}>
                      <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                    </ContentLoader>
                  </div>
                </div>
              </div>
            ) : (
              fields?.length > 0 ?
                <>
                  <div className='innercardClassInner'>
                    {fields?.map((record, index) => (
                      <div key={record.id} className='row'>
                        <div className={`col-4`}>
                          <div className='accountSecondaryText text-uppercase'>
                            <Currency
                              currency={record?.baseCurrency}
                            />
                          </div>
                        </div>
                        <div className={`col-4`}>
                          <div className='accountSecondaryText text-uppercase text-center'>
                            <Currency
                              currency={record?.paidCurrency}
                            />
                            <CurrencyFormat
                              currency={record?.paidCurrency}
                              value={parseFloat(record?.paidAmount)}
                              decimal={2}
                            />
                          </div>
                        </div>
                        <div className={`col-4`}>
                          <div className='accountSecondaryText text-uppercase text-right'>
                            <Currency
                              currency={record?.baseCurrency}
                            />
                            <CurrencyFormat
                              currency={record?.baseCurrency}
                              value={parseFloat(record?.baseAmount)}
                              decimal={2}
                            /></div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {fields?.length < 3 &&
                    <div className="whiteSpacediv">
                      <p>Your cash balance powers your payouts. Keep it active to grow your business.</p>
                      <div
                        className="company-add-btn"
                        onClick={addFunds}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <path d="M13.4141 9.13477H10.5938V6.31445C10.5938 6.23281 10.527 6.16602 10.4453 6.16602H9.55469C9.47305 6.16602 9.40625 6.23281 9.40625 6.31445V9.13477H6.58594C6.5043 9.13477 6.4375 9.20156 6.4375 9.2832V10.1738C6.4375 10.2555 6.5043 10.3223 6.58594 10.3223H9.40625V13.1426C9.40625 13.2242 9.47305 13.291 9.55469 13.291H10.4453C10.527 13.291 10.5938 13.2242 10.5938 13.1426V10.3223H13.4141C13.4957 10.3223 13.5625 10.2555 13.5625 10.1738V9.2832C13.5625 9.20156 13.4957 9.13477 13.4141 9.13477Z" fill="white" />
                          <path d="M10 1.41602C5.40957 1.41602 1.6875 5.13809 1.6875 9.72852C1.6875 14.3189 5.40957 18.041 10 18.041C14.5904 18.041 18.3125 14.3189 18.3125 9.72852C18.3125 5.13809 14.5904 1.41602 10 1.41602ZM10 16.6309C6.18887 16.6309 3.09766 13.5396 3.09766 9.72852C3.09766 5.91738 6.18887 2.82617 10 2.82617C13.8111 2.82617 16.9023 5.91738 16.9023 9.72852C16.9023 13.5396 13.8111 16.6309 10 16.6309Z" fill="white" />
                        </svg>
                        <p>Add funds</p>
                      </div>
                    </div>
                  }
                </>
                :
                <div className="whiteSpacediv">
                  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="61" viewBox="0 0 80 61" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 6.90534V13.5822H4.76191H9.52381V11.1255V8.66894L7.24044 8.61022L4.95692 8.55169L4.52982 7.95425C3.98901 7.19803 3.98916 6.6123 4.53011 5.85644L4.95766 5.259L39.1455 5.20541C63.3404 5.16736 73.4936 5.20961 73.8819 5.34955C74.4274 5.54638 74.8718 6.2448 74.8718 6.90534C74.8718 7.42724 74.4636 8.20065 74.07 8.42455C73.8287 8.56193 72.897 8.64315 71.564 8.64315H69.4421L69.4829 11.0669L69.5238 13.4907L74.7619 13.5388L80 13.5867V6.90772V0.228516H40H0V6.90534ZM12.1612 34.4358V60.2285H39.4872H66.8132V34.4358V8.64315H65.4945H64.1758V26.4926V44.3421L63.7475 44.8767C63.4035 45.3063 63.1919 45.4114 62.6721 45.4114C61.7793 45.4114 59.9037 46.0365 59.0447 46.62C58.0571 47.2912 56.8312 48.6966 56.2322 49.8445C55.4551 51.3339 55.0879 52.6074 54.9087 54.4356C54.7679 55.8703 54.6862 56.1853 54.343 56.6157L53.942 57.1188H39.4872H25.0324L24.6041 56.5841C24.2601 56.1546 24.1758 55.8904 24.1758 55.2414C24.1758 54.1213 23.676 51.791 23.1925 50.6569C22.6736 49.4399 20.9492 47.287 19.9744 46.6391C19.0659 46.0354 17.1994 45.4114 16.3023 45.4114C15.7824 45.4114 15.5708 45.3063 15.2268 44.8767L14.7985 44.3421V26.4926V8.64315H13.4799H12.1612V34.4358ZM17.4718 25.4185L17.5092 42.1938L18.4091 42.4211C22.3717 43.4225 25.7678 47.6563 26.5681 52.5932L26.7531 53.7346H39.4738H52.1944L52.4728 52.3627C53.4642 47.4763 56.5284 43.6275 60.3152 42.5121L61.4652 42.1733L61.5026 25.4082L61.5399 8.64315H56.629H51.718L52.1115 9.42059C53.6815 12.5219 54.4372 16.925 54.0661 20.8078C53.2387 29.4633 47.8481 36.0952 40.9182 36.9831C38.1887 37.3327 35.5776 36.7306 33.0338 35.165C25.658 30.6249 22.7291 19.4885 26.5059 10.3438L27.2082 8.64315H22.3213H17.4344L17.4718 25.4185ZM29.9641 9.69498C29.0388 11.163 28.1968 13.3797 27.8273 15.32C27.4111 17.5043 27.4838 21.0388 27.9852 23.0029C29.2678 28.0277 32.1635 31.6215 36.1905 33.1857C37.1461 33.557 37.5855 33.6119 39.5604 33.6075C41.7396 33.6028 41.8879 33.5783 43.2234 33.0037C45.0399 32.2224 46.3741 31.2192 47.7197 29.6236C50.4415 26.3956 51.8275 21.841 51.4404 17.3977C51.1777 14.3823 50.2001 11.3538 48.8655 9.42059L48.3288 8.64315H44.604H40.8791V9.55778V10.4724H41.7695C42.5582 10.4724 42.7089 10.5335 43.0882 11.0071C43.3805 11.3721 43.5165 11.7251 43.5165 12.1188C43.5165 12.5124 43.3805 12.8655 43.0882 13.2304C42.6639 13.76 42.6438 13.7651 40.9563 13.7651C38.6569 13.7651 38.2418 14.0344 38.2418 15.5261C38.2418 16.4669 38.7201 16.9702 39.7594 17.1225C42.4409 17.516 44.1184 20.641 43.2857 23.6918C43.0116 24.6963 42.1424 25.9868 41.4069 26.4813C40.8939 26.8263 40.8791 26.8658 40.8791 27.9011C40.8791 29.5457 40.399 30.4114 39.4872 30.4114C38.6097 30.4114 38.0952 29.5008 38.0952 27.9478V27.1188H37.3553C36.4448 27.1188 35.8476 26.7544 35.6166 26.058C35.3896 25.374 35.5417 24.646 36.0069 24.189C36.3265 23.8751 36.6028 23.8261 38.0491 23.8261C39.9354 23.8261 40.435 23.6252 40.7253 22.7507C41.1073 21.5993 40.5062 20.6313 39.293 20.4434C37.6747 20.193 36.5868 19.2846 35.9418 17.6446C35.6123 16.807 35.5338 16.3652 35.5442 15.4114C35.5515 14.7575 35.6618 13.9188 35.7895 13.5474C36.0864 12.684 37.0993 11.3089 37.647 11.0258C38.0369 10.824 38.0744 10.7208 38.1196 9.72461L38.1685 8.64242L34.3978 8.64278L30.627 8.64315L29.9641 9.69498Z" fill="url(#paint0_linear_15209_11052)" fillOpacity="0.25" />
                    <defs>
                      <linearGradient id="paint0_linear_15209_11052" x1="40" y1="0.228516" x2="40" y2="60.2285" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#2978B5" />
                        <stop offset="1" stopColor="#12344F" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <p>No cash balance yet</p>
                  <div
                    className="company-add-btn"
                    onClick={addFunds}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M13.4141 9.13477H10.5938V6.31445C10.5938 6.23281 10.527 6.16602 10.4453 6.16602H9.55469C9.47305 6.16602 9.40625 6.23281 9.40625 6.31445V9.13477H6.58594C6.5043 9.13477 6.4375 9.20156 6.4375 9.2832V10.1738C6.4375 10.2555 6.5043 10.3223 6.58594 10.3223H9.40625V13.1426C9.40625 13.2242 9.47305 13.291 9.55469 13.291H10.4453C10.527 13.291 10.5938 13.2242 10.5938 13.1426V10.3223H13.4141C13.4957 10.3223 13.5625 10.2555 13.5625 10.1738V9.2832C13.5625 9.20156 13.4957 9.13477 13.4141 9.13477Z" fill="white" />
                      <path d="M10 1.41602C5.40957 1.41602 1.6875 5.13809 1.6875 9.72852C1.6875 14.3189 5.40957 18.041 10 18.041C14.5904 18.041 18.3125 14.3189 18.3125 9.72852C18.3125 5.13809 14.5904 1.41602 10 1.41602ZM10 16.6309C6.18887 16.6309 3.09766 13.5396 3.09766 9.72852C3.09766 5.91738 6.18887 2.82617 10 2.82617C13.8111 2.82617 16.9023 5.91738 16.9023 9.72852C16.9023 13.5396 13.8111 16.6309 10 16.6309Z" fill="white" />
                    </svg>
                    <p>Add funds</p>
                  </div>
                </div>
            )}
            {isUserDashboardLoading ? (
              <div className='innercardClassInner'>
                <div className='row'>
                  <div className='col-6'>
                    <ContentLoader width="72%" height={50}>
                      <rect x="0" y="0" rx="10" ry="10" width="72%" height="40" />
                    </ContentLoader>
                  </div>
                  <div className='col-6 skeletonFlexEnd'>
                    <div style={{ width: '65%', marginLeft: 'auto' }}>
                      <ContentLoader width="100%" height={50}>
                        <rect x="0" y="0" rx="10" ry="10" width="100%" height="40" />
                      </ContentLoader>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              fields?.length > 2 &&
              <div className='row BottomRowAddFund'>
                <div className='col-6'>
                  {/* sendMessageToAdmin(MESSAGE_TYPE.USER_DASHBOARD, "<strong>Add funds</strong>: I am interested to add funds to my account", 1)} */}
                  <button disabled={(adminLoader === 1 || adminLoader > 0) ? true : false} type="button" onClick={addFunds} className='customFilterButton mobileViewImportButton'>
                    {adminLoader === 1 && (<i className="animateSpin fa-solid fa-circle-notch"></i>)} Add funds
                  </button>
                </div>
                {selectedCompany?.isWithdraw &&
                  <div className='col-6 text-right'>
                    <button disabled={(adminLoader === 2 || adminLoader > 0) ? true : false} type="button" onClick={() => sendMessageToAdmin(MESSAGE_TYPE.USER_DASHBOARD, `<strong>Withdraw funds</strong>: I am interested to withdraw funds for ${companyLink(selectedCompany)}`, 2)} className='customImportButton mobileViewImportButton m-0'>
                      {adminLoader === 2 && (<i className="animateSpin fa-solid fa-circle-notch"></i>)} Withdraw funds
                    </button>
                  </div>
                }
              </div>
            )}
          </div>
        </div>
      </form>
    </>
  )
}
